<template>
  <div>
    <vueper-slides disable-arrows-on-edges :touchable="false" :style="displayTour || displaySetInstance ? 'display: none;' : 'display: block;'">
      <vueper-slide>
        <template v-slot:content>
          <screen>
            <img slot="icon" class="logo" src="./assets/logo.svg" />
            <span slot="title">Welcome to <strong>HARMONY</strong> PSA</span>
            <div slot="content">
              <div>The mobile application for the most functionally complete PSA solution on the market.</div>
              <div class="buttons">
                <md-button class="md-raised md-primary" @click="viewTour" >View the tour</md-button>
                <md-button class="md-raised md-secondary" @click="skipTour" >Skip to login</md-button>
              </div>
            </div>
          </screen>
        </template>
      </vueper-slide>
    </vueper-slides>

    <div id="slideshow" :style="displayTour ? 'display: block;' : 'display: none;'">
      <vueper-slides class="no-shadow" disable-arrows-on-edges :touchable="false" >
        <vueper-slide v-for="i in 8" :key="i">
          <template v-slot:content>
            <screen v-show="i == 1" color="rgb(220, 236, 251)">
              <img slot="icon" src="./assets/blue/undraw_schedule_pnbk.svg" />
              <span slot="title">Manage your tickets</span>
              <div slot="content">
               Create, respond, update and close tickets with ease. Search for tickets with full text search capability, complete check-lists and obtain client sign-off while on site.
              </div>
            </screen>
            <screen v-show="i == 2" color="rgb(255, 246, 231)">
              <img slot="icon" src="./assets/yellow/undraw_cloud_sync_2aph.svg" />
              <span slot="title">Manage your client’s assets</span>
              <div slot="content">
                Client assets can be found, updated, reviewed for ticket activity and the associated knowledge base articles read and guidance followed without needing desktop access.
              </div>
            </screen>
            <screen v-show="i == 3" color="rgb(255, 231, 228)">
              <img slot="icon" src="./assets/red/undraw_time_management_30iu.svg" />
              <span slot="title">Manage your time</span>
              <div slot="content">
                View calendar bookings, close actions, start, pause and close timers. Fast and easy time management on the go.
              </div>
            </screen>
            <screen v-show="i == 4" color="rgb(220, 236, 251)">
              <img slot="icon" src="./assets/blue/undraw_printing_invoices_5r4r.svg" />
              <span slot="title">Manage your expenses</span>
              <div slot="content">
                Enter expenses, photograph receipts and submit them for approval. Billable, non-billable or overhead expenses in any currency.
              </div>
            </screen>
            <screen v-show="i == 5" color="rgb(255, 246, 231)">
              <img slot="icon" src="./assets/yellow/undraw_setup_analytics_8qkl.svg" />
              <span slot="title">Manage your sales leads</span>
              <div slot="content">
                Update sales leads, post activity, convert leads to opportunities straight after the meeting. 
              </div>
            </screen>
            <screen v-show="i == 6" color="rgb(255, 231, 228)">
              <img slot="icon" src="./assets/red/undraw_process_e90d.svg" />
              <span slot="title">Manage your sales pipeline</span>
              <div slot="content">
                Create opportunities, update deal profiles, change opportunity stages, add activity posts and expenses. Never let opportunities go stale.
              </div>
            </screen>
            <screen v-show="i == 7" color="rgb(220, 236, 251)">
              <img slot="icon" src="./assets/blue/undraw_people_search_wctu.svg" />
              <span slot="title">Manage your contacts</span>
              <div slot="content">
                Add and update contacts, create and amend external users, update counterparty records, add or amend counterpart addresses and document preferences while you meet.
              </div>
            </screen>
            <screen v-show="i == 8" color="rgb(255, 246, 231)">
              <img slot="icon" src="./assets/yellow/undraw_accept_request_vdsd.svg" />
              <span slot="title">Manage your approvals</span>
              <div slot="content">
                Need to approve quotes, expenses etc. while away from your desk? Email notifications take you straight to the page while you are travelling.
              </div>
            </screen>
          </template>
        </vueper-slide>
      </vueper-slides>
      <md-button class="md-raised md-primary getStartedButton" @click="endTour" style="z-index:100000;" >Let's get started!</md-button>
    </div>
    <set-instance :style="displaySetInstance ? 'display: flex;' : 'display: none;'"></set-instance>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import screen from './components/Screen'
import setInstance from './pages/SetInstance'
import 'vueperslides/dist/vueperslides.css'

var isGoNative = navigator.userAgent.indexOf("goNative") > -1;

if(isGoNative) {
  setTimeout(() => {
    window.location.href = 'gonative://navigationTitles/setCurrent?title=' + encodeURIComponent("Welcome");
  }, 250);
}

export default {
  name: 'App',
  components: { VueperSlides, VueperSlide, screen, setInstance },
  data() {
    return {
      displaySetInstance: false,
      displayTour: false
    }
  },
  methods: {
    viewTour() {
      this.displayTour = true;
    },
    skipTour() {
      this.displaySetInstance = true;
    },
    endTour() { 
      this.displayTour = false;
      setTimeout(() => { this.displaySetInstance = true; }, 250);
    }
  }
}
</script>

<style lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
  primary: md-get-palette-color(blue, 700), // The primary color of your application
  accent: md-get-palette-color(red, 700) // The accent or secondary color
));

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>

<style lang="scss">
.logo {
  width: 70%;
}

.buttons {
  margin-top: 10px;
}

.vueperslides {
    background: #eeeeee;
    z-index: 1000;

  .vueperslides__parallax-wrapper {
    height: 100vh;
  }

  .vueperslides__bullet {
    border-color: #96ceff;
  }
}

#slideshow {
  z-index: 2000 !important;


  .md-title {
    font-size: 20px;
  }

  .vueperslides__parallax-wrapper {
    height: 92vh;
  }

.vueperslides__arrow svg {
  color: #aaa;
}

  .getStartedButton {
    height:8vh;
    margin: 0;
    width: 100%;
  }

  .icon {
    box-shadow: inset 0px -11px 8px -10px #aaa;
  }

  .content,
  .md-caption {
    background-color: #fafafa;
  }
}

.set-instance {
    position: absolute;
    z-index: 1000;
    top: 0;
}
</style>
